// extracted by mini-css-extract-plugin
export default {"logo":"ProfilePage_logo__jBBqU"};